export const demoAccounts = [
  'partner-id-entertainment',
  'partner-id-marketing',
  'partner-id-sport',
  'partner-id-test',
]

// Partners Google's app reviewers log in as; they don't see test-campaign or share-link actions.
export const REVIEW_CLIENT_PARTNER_IDS = ['partner-id-google']

export const SUPPORT_ARTICLE_URLS = {
  meta: {
    en: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/971505683',
    de: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1032454214',
  },
  leadForms: {
    en: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/971014546',
    de: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1032388629',
  },
  languageVariations: {
    en: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1048838145?source=search',
    de: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1049067521?source=search',
  },
  eventSeries: {
    en: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/971505755',
    de: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1029636101',
  },
  integrations: {
    en: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/971046987',
    de: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1044676612',
  },
  media: {
    en: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/971603969',
    de: 'https://kb.support.future-demand.com/servicedesk/customer/portal/5/article/1025343492',
  },
}

const constants = {
  API_URL: process.env.REACT_APP_API,
  CR_URL: process.env.REACT_APP_CR_API,
  APP_TIMEOUT: process.env.REACT_APP_APP_TIMEOUT ? process.env.REACT_APP_APP_TIMEOUT : 1200000,
  SENTRY_SAMPLING_RATE: process.env.REACT_APP_SENTRY_SAMPLING_RATE,
  MAX_IMG_UPLOAD_SIZE: Number(
    process.env.REACT_APP_MAX_UPLOAD_MB_IMAGE ? process.env.REACT_APP_MAX_UPLOAD_MB_IMAGE : 1,
  ),
  MAX_VIDEO_UPLOAD_SIZE: Number(
    process.env.REACT_APP_MAX_UPLOAD_MB_VIDEO ? process.env.REACT_APP_MAX_UPLOAD_MB_VIDEO : 1,
  ),
  NOTIFICATION_PULL_INTERVAL: Number(
    process.env.REACT_APP_NOTIFICATION_PULL_INTERVAL
      ? process.env.REACT_APP_NOTIFICATION_PULL_INTERVAL
      : 10000,
  ),

  //eslint-disable-next-line no-useless-escape
  URL_VALIDATION_REGEX:
    /^(http(s)?:\/\/|www\.)[a-zA-Z0-9@:%._\-+~#=]{2,256}\.[a-z]{2,6}(\b|)([^\s]*)$/,
  API_VERSION: process.env.REACT_APP_API_VERSION || 'v4',
  GOOGLE_ADS_CLIENT_ID: process.env.REACT_APP_GOOGLE_ADS_CLIENT_ID,
}

export default constants
